import React, { Fragment, useState } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import Rating from 'react-rating';
import HeaderCard from '../../Common/HeaderCard';

const HalfStar = () => {
  const [rating, setRating] = useState(2.5);
  return (
    <Fragment>
      <Col xl='6' lg='12' md='6'>
        <Card>
          <HeaderCard title={'Half Star Rating'} />
          <CardBody>
            <div className='rating'>
              <Rating size={'16px'} initialRating={rating} fractions={2} emptySymbol='star fa fa-star-o fa-2x' fullSymbol='star fa fa-star fa-2x' onChange={(rate) => setRating(rate)}></Rating>
              <span className='current-rating'>{rating}</span>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default HalfStar;
